"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateUser = (signedInUser) => {
    return {
        type: 'UPDATE_USER',
        name: signedInUser.name,
        handle: signedInUser.handle,
        avatarUrl: signedInUser.avatarUrl,
    };
};
exports.defaultUser = {
    language: 'en',
};
exports.user = (state = exports.defaultUser, action) => {
    switch (action.type) {
        case 'UPDATE_USER':
            return Object.assign({}, state, { name: action.name, handle: action.handle, avatarUrl: action.avatarUrl });
        case 'UPDATE_LANGUAGE':
            return Object.assign({}, state, { language: action.language });
        default:
            return state;
    }
};
